import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BiteMarkLanding from "./BiteMarkLanding";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";
import Waitlist from "./Waitlist";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BiteMarkLanding />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
      </Routes>
    </Router>
  );
}
